import {post} from '../../request'
import {push} from "echarts/src/component/dataZoom/history";



/**
 * 创建文章
 * @param data
 * @returns {*}
 */
export function createArticle(data) {
    return post("admin/article.article/add", data)
}

/**
 * 获取修改的数据
 * @param data
 * @returns {*}
 */
export function getEditData(data){
    return post("admin/article.article/getEditData", data);
}
/**
 * 修改文章
 * @param data
 * @returns {*}
 */
export function editsArticle(data) {
    return post("admin/article.article/edits", data)
}

/**
 * 文章列表
 * @param data
 * @returns {*}
 */
export function articleList(data) {
    return post("admin/article.article/index", data)
}


/**
 * 文章分类
 * @param data
 * @returns {*}
 */
export function getArticleCategory(data) {
    return post("admin/article.article/getArticleCategory", data)
}

/**
 * 删除文章
 * @param data
 * @returns {*}
 */
export function deleteArticle(data) {
    return post("admin/article.article/delete", data)
}



/**
 * 删除文章
 * @param data
 * @returns {*}
 */
export function onlineArticle(data) {
    return post("admin/article.article/online", data)
}

/**
 * 启用/禁用
 * @param data
 * @returns {*}
 */
export function isstatusArticle(data) {
    return post("admin/article.article/isstatus", data)
}

/**
 * 是否微信专属
 * @param data
 * @returns {*}
 */
export function isexclusive(data) {
    return post("admin/article.article/exclusive", data)
}

